import { AxiosClientFactory } from '../../../common/helpers/AxiosClientFactory';
import {AxiosResponse} from "axios";
import {CustomerCommunicationEmail} from "../../../common/models/CustomerCommunicationEmail";

export const getEmail =  (id: number): Promise<AxiosResponse<CustomerCommunicationEmail>> => {
    return AxiosClientFactory
        .getInstance()
        .get(`/api/outboundemails/${id}`);
};
